'use strict';

var _regeneratorRuntime = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _objectSpread = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread");

var _awaitAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/ws/61941e029dd8eb000197c556/095e8b3251cd4da4bfbd4c9ec23a8ade/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var CID = require('cids');

var configure = require('../lib/configure');

var normaliseInput = require('ipfs-core-utils/src/pins/normalise-input');

var toUrlSearchParams = require('../lib/to-url-search-params');

module.exports = configure(function (api) {
  return /*#__PURE__*/function () {
    var _addAll = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(source) {
      var options,
          _iteratorNormalCompletion,
          _didIteratorError,
          _iteratorError,
          _iterator,
          _step,
          _value,
          _value3,
          path,
          recursive,
          metadata,
          res,
          _iteratorNormalCompletion2,
          _didIteratorError2,
          _iteratorError2,
          _iterator2,
          _step2,
          _value2,
          pin,
          _iterator3,
          _step3,
          cid,
          _args = arguments;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              options = _args.length > 1 && _args[1] !== undefined ? _args[1] : {};
              _iteratorNormalCompletion = true;
              _didIteratorError = false;
              _context.prev = 3;
              _iterator = _asyncIterator(normaliseInput(source));

            case 5:
              _context.next = 7;
              return _awaitAsyncGenerator(_iterator.next());

            case 7:
              _step = _context.sent;
              _iteratorNormalCompletion = _step.done;
              _context.next = 11;
              return _awaitAsyncGenerator(_step.value);

            case 11:
              _value = _context.sent;

              if (_iteratorNormalCompletion) {
                _context.next = 73;
                break;
              }

              _value3 = _value, path = _value3.path, recursive = _value3.recursive, metadata = _value3.metadata;
              _context.next = 16;
              return _awaitAsyncGenerator(api.post('pin/add', {
                timeout: options.timeout,
                signal: options.signal,
                searchParams: toUrlSearchParams(_objectSpread({}, options, {
                  arg: path,
                  recursive: recursive,
                  metadata: metadata ? JSON.stringify(metadata) : undefined,
                  stream: true
                })),
                headers: options.headers
              }));

            case 16:
              res = _context.sent;
              _iteratorNormalCompletion2 = true;
              _didIteratorError2 = false;
              _context.prev = 19;
              _iterator2 = _asyncIterator(res.ndjson());

            case 21:
              _context.next = 23;
              return _awaitAsyncGenerator(_iterator2.next());

            case 23:
              _step2 = _context.sent;
              _iteratorNormalCompletion2 = _step2.done;
              _context.next = 27;
              return _awaitAsyncGenerator(_step2.value);

            case 27:
              _value2 = _context.sent;

              if (_iteratorNormalCompletion2) {
                _context.next = 54;
                break;
              }

              pin = _value2;

              if (!pin.Pins) {
                _context.next = 49;
                break;
              }

              // non-streaming response
              _iterator3 = _createForOfIteratorHelper(pin.Pins);
              _context.prev = 32;

              _iterator3.s();

            case 34:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 40;
                break;
              }

              cid = _step3.value;
              _context.next = 38;
              return new CID(cid);

            case 38:
              _context.next = 34;
              break;

            case 40:
              _context.next = 45;
              break;

            case 42:
              _context.prev = 42;
              _context.t0 = _context["catch"](32);

              _iterator3.e(_context.t0);

            case 45:
              _context.prev = 45;

              _iterator3.f();

              return _context.finish(45);

            case 48:
              return _context.abrupt("continue", 51);

            case 49:
              _context.next = 51;
              return new CID(pin);

            case 51:
              _iteratorNormalCompletion2 = true;
              _context.next = 21;
              break;

            case 54:
              _context.next = 60;
              break;

            case 56:
              _context.prev = 56;
              _context.t1 = _context["catch"](19);
              _didIteratorError2 = true;
              _iteratorError2 = _context.t1;

            case 60:
              _context.prev = 60;
              _context.prev = 61;

              if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                _context.next = 65;
                break;
              }

              _context.next = 65;
              return _awaitAsyncGenerator(_iterator2.return());

            case 65:
              _context.prev = 65;

              if (!_didIteratorError2) {
                _context.next = 68;
                break;
              }

              throw _iteratorError2;

            case 68:
              return _context.finish(65);

            case 69:
              return _context.finish(60);

            case 70:
              _iteratorNormalCompletion = true;
              _context.next = 5;
              break;

            case 73:
              _context.next = 79;
              break;

            case 75:
              _context.prev = 75;
              _context.t2 = _context["catch"](3);
              _didIteratorError = true;
              _iteratorError = _context.t2;

            case 79:
              _context.prev = 79;
              _context.prev = 80;

              if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                _context.next = 84;
                break;
              }

              _context.next = 84;
              return _awaitAsyncGenerator(_iterator.return());

            case 84:
              _context.prev = 84;

              if (!_didIteratorError) {
                _context.next = 87;
                break;
              }

              throw _iteratorError;

            case 87:
              return _context.finish(84);

            case 88:
              return _context.finish(79);

            case 89:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 75, 79, 89], [19, 56, 60, 70], [32, 42, 45, 48], [61,, 65, 69], [80,, 84, 88]]);
    }));

    function addAll(_x) {
      return _addAll.apply(this, arguments);
    }

    return addAll;
  }();
});